import React from 'react';
import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';

const X = ({ size, color, theme, iconTitle }) => {
  const iconColor = color || (theme && theme.iconColor);
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 12 12"
      color={iconColor}
      fill={iconColor}
    >
      <title>{iconTitle}</title>
      <defs>
        <filter id="filter-1">
          <feColorMatrix
            in="SourceGraphic"
            type="matrix"
            values="0 0 0 0 0.200000 0 0 0 0 0.200000 0 0 0 0 0.200000 0 0 0 1.000000 0"
          ></feColorMatrix>
        </filter>
      </defs>
      <g
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <g filter="url(#filter-1)">
          <g>
            <line
              x1="12"
              y1="0"
              x2="0"
              y2="12"
              stroke="#000000"
              stroke-width="2"
            ></line>
            <line
              x1="0"
              y1="0"
              x2="12"
              y2="12"
              stroke="#000000"
              stroke-width="2"
            ></line>
          </g>
        </g>
      </g>
    </svg>
  );
};

X.propTypes = {
  color: PropTypes.string,
  iconTitle: PropTypes.string,
  size: PropTypes.number,
  theme: PropTypes.object,
};

X.defaultProps = {
  color: null,
  iconTitle: null,
  size: 26,
  theme: null,
};

export default withTheme(X);
